import { Check, X } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'
import type { ChangeSetRoundDecision, WorkflowChangeSet } from '@/api/workflowChangeSets'

function RoundDecisionButton({ action, round, disabled, onClick }: {
  action: 'stage' | 'discard'
  round: number
  disabled: boolean
  onClick: () => void
}) {
  const label = action === 'stage' ? 'Stage All' : 'Discard All'
  const Icon = action === 'stage' ? Check : X
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex">
          <Button
            variant="ghost"
            size="icon"
            aria-label={`${label} changes in Round ${round}`}
            disabled={disabled}
            className={cn(
              'group h-5 w-5 shrink-0 hover:bg-transparent',
              action === 'stage'
                ? 'text-success-foreground hover:text-success-foreground'
                : 'text-danger-foreground hover:text-danger-foreground',
            )}
            onClick={onClick}
          >
            <Icon className="h-3.5 w-3.5 transition-transform duration-150 group-hover:scale-125 group-active:scale-90" />
          </Button>
        </span>
      </TooltipTrigger>
      <TooltipContent className="font-normal">{label}</TooltipContent>
    </Tooltip>
  )
}

export function RoundDecisionActions({ changeSet, onDecide }: {
  changeSet: WorkflowChangeSet
  onDecide: (decision: ChangeSetRoundDecision) => void
}) {
  const stagedCount = changeSet.items.filter((i) => i.decision === 'Staged').length
  return (
    <span className="relative z-10 flex shrink-0 items-center gap-0.5">
      <RoundDecisionButton
        action="stage"
        round={changeSet.round}
        disabled={stagedCount === changeSet.items.length}
        onClick={() => onDecide('Staged')}
      />
      <RoundDecisionButton
        action="discard"
        round={changeSet.round}
        disabled={stagedCount === 0}
        onClick={() => onDecide('Unstaged')}
      />
    </span>
  )
}
